import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/activityHistory/main"));

const ActiveHistory = () => {
  return (
    <Layout pageHeading="Activity History">
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    </Layout>
  );
};

export default ActiveHistory;
